import React from "react";
import { generatePath, Link } from "react-router-dom";
import StyledTooltip from "./Wrapper/StyledTooltip";

type PathParams = { requestId: string; tab: number };
type SearchParams = Record<string, string>;

interface DeepLinkProps {
  label: string;
  pathParams: PathParams;
  searchParams?: SearchParams;
  LinkProps?: React.AnchorHTMLAttributes<HTMLAnchorElement>;
}

function DeepLink({ label, pathParams, searchParams, LinkProps }: DeepLinkProps) {
  const pathname = generatePath("/requests/:requestId([A-Z0-9]{6})/:tab([0-5])", pathParams);
  const search = searchParams ? `?${new URLSearchParams(searchParams)}` : "";
  return (
    <StyledTooltip title={label}>
      <Link className="LEAPLink" to={{ pathname, search }} {...(LinkProps || {})}>
        {label}
      </Link>
    </StyledTooltip>
  );
}

export default DeepLink;
